"use client";
import { useState } from "react";
import Swal from "sweetalert2";
import styles from "@/app/components/styles/Form.module.scss";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    interest: "",
    message: "",
  });

  const interests = [
    "Engagement Rings",
    "Necklaces",
    "Earrings",
    "Custom Design",
    "Other",
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
    setFormData({
      name: "",
      email: "",
      phone: "",
      interest: "",
      message: "",
    });
    Swal.fire({
      icon: "success",
      title: "Success",
      text: "Your inquiry has been sent!",
    });
  };

  return (
    <section className={styles.container}>
      <h2 className={styles.title}>Contact Us</h2>
      <p className={styles.description}>
        We'd love to help you find the perfect piece.
      </p>

      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.formGroup}>
          <input
            type="text"
            name="name"
            placeholder="Your full name"
            value={formData.name}
            onChange={handleChange}
            required
            className={styles.input}
          />
        </div>

        <div className={styles.formGroup}>
          <input
            type="email"
            name="email"
            placeholder="you@example.com"
            value={formData.email}
            onChange={handleChange}
            required
            className={styles.input}
          />
        </div>

        <div className={styles.formGroup}>
          <input
            type="tel"
            name="phone"
            placeholder="Mobile number"
            value={formData.phone}
            onChange={handleChange}
            required
            className={styles.input}
          />
        </div>

        <div className={styles.formGroup}>
          <select
            name="interest"
            value={formData.interest}
            onChange={handleChange}
            required
            className={styles.input}
          >
            <option value="" className={styles.optionPlaceholder}>
              Select an option
            </option>
            {interests.map((item, idx) => (
              <option key={idx} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>

        <div className={styles.formGroup}>
          <textarea
            name="message"
            placeholder="Tell us what you're looking for..."
            value={formData.message}
            onChange={handleChange}
            rows={4}
            required
            className={styles.textareaField}
          />
        </div>

        <button type="submit" className={styles.button}>
          Send Inquiry
        </button>
      </form>
    </section>
  );
};

export default ContactForm;
